import { useMemo, ReactElement } from 'react';
import { Header } from '../../../common_v2/components/Header';
import { Footer } from '../../../common_v2/components/Footer';
import { isMobileScreen } from '@apply/ui';
import { useAuthentication } from '../../../LoginPage';
import { FeatureType } from '@apply/constants';
import { HomePageLink } from '../../../HomePageLink';
import { DrawControl } from './DrawControl';
import { MobileDrawControl } from './MobileDrawControl/MobileDrawControl';

function DrawSummary(): ReactElement {
    const mobileScreen = isMobileScreen();
    const { isFeatureEnabled } = useAuthentication();

    const isDrawsEnabled: boolean = useMemo(() => isFeatureEnabled(FeatureType.Draws), [isFeatureEnabled]);

    if (!isDrawsEnabled) {
        return (
            <>
                <Header />
                <HomePageLink />
                <h1 style={{ margin: 20, color: 'black' }}>Feature is currently turned off.</h1>
            </>
        );
    }

    return (
        <>
            <div className='app-container'>
                <Header />
                {!mobileScreen && <DrawControl />}
                {mobileScreen && <MobileDrawControl />}
            </div>
            <Footer />
        </>
    );
}

export default DrawSummary;
